import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import Iconify from "../../../components/Iconify";
import FrmAgregarBanco from "./Forms/FrmAgregarBanco";
const AddBancoButtom = ({
  setOpenDialog,
  setBodyDialog,
  setOpenSnackBar,
  setErrorGraph,
}) => {
  const handleOpenDialog = () => {
    setBodyDialog(
      <FrmAgregarBanco
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
      />
    );
    setOpenDialog(true);
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={5}
    >
      <Typography variant="h4" gutterBottom>
        Cuentas Bancarias
      </Typography>
      <Button
        onClick={() => handleOpenDialog()}
        startIcon={<Iconify icon="eva:plus-fill" />}
      >
        Nuevo registro
      </Button>
    </Stack>
  );
};

export default AddBancoButtom;
